import {ExamParticipantDto, ExamStationDto, ParticipantType, SessionRunParticipantStateType, SupportRequest} from "@models";

export enum ExamParticipantDisplayState {
	Ready,
	Pending,
	Absent,
	Help,
}

export type ExamParticipantDisplayStateMapping = {
	[ParticipantType.Instructor]?: ExamParticipantDisplayState;
	[ParticipantType.StandardizedPatient]?: ExamParticipantDisplayState;
	[ParticipantType.Learner]: ExamParticipantDisplayState;
};

export function computeParticipantState(station: ExamStationDto, supportRequests: SupportRequest[]): ExamParticipantDisplayStateMapping {
	// Local func
	const determineParticipantState = (participant?: ExamParticipantDto): ExamParticipantDisplayState => {
		const supportRequest = supportRequests.find(
			(supportRequest) => participant?.userId === supportRequest.userId && !supportRequest.resolvedAt,
		);
		if (supportRequest) {
			return ExamParticipantDisplayState.Help;
		} else {
			let localResult = ExamParticipantDisplayState.Pending;
			if (participant?.participantState === SessionRunParticipantStateType.Ready) {
				localResult = ExamParticipantDisplayState.Ready;
			} else if (participant?.participantState === SessionRunParticipantStateType.Aborted) {
				localResult = ExamParticipantDisplayState.Absent;
			}
			return localResult as ExamParticipantDisplayState;
		}
	};

	// Build result
	const result = {
		[ParticipantType.Learner]: determineParticipantState(station.studentParticipant),
	} as ExamParticipantDisplayStateMapping;

	if (station.examinerParticipant) {
		result[ParticipantType.Instructor] = determineParticipantState(station.examinerParticipant);
	}

	if (station.standardizedPatientParticipant) {
		result[ParticipantType.StandardizedPatient] = determineParticipantState(station.standardizedPatientParticipant);
	}

	return result;
}
